<template>
  <div class="Challenges">
    <ChallengeHome v-if="current_target==='home'" @switch="onSwitch"></ChallengeHome>
    <ChallengeCreate v-if="current_target==='create'" cid="" @switch="onSwitch"></ChallengeCreate>
    <ChallengeCreate v-if="current_target==='detail'" :cid="selected_id" @switch="onSwitch"></ChallengeCreate>
  </div>
</template>

<script>
  import ChallengeHome from '@/components/Challenges/ChallengeHome/ChallengeHome'
  import ChallengeCreate from '@/components/Challenges/ChallengeCreate/ChallengeCreate'
  // import ChallengeDetail from '@/components/Challenges/ChallengeDetail/ChallengeDetail'

  export default {
    components: {
      ChallengeHome,
      ChallengeCreate,
      // ChallengeDetail,
    },
    props: ['target'],
    data: () => {
      return {
        selected_id:'',
        current_target: 'home'
      }
    },
    beforeMount(){
      this.current_target = this.$route.params.target?this.$route.params.target:"home"
    },
    methods:{
      onSwitch(event){
        this.selected_id = event.id?event.id:'';
        this.current_target = event.target
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "_Challenges.scss";
</style>